import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import SearchBar from '../components/SearchBar';
import ProviderCard from '../components/ProviderCard';
import { fetchProviders } from '../api/client';

export default function Buscar() {
  const [searchParams] = useSearchParams();
  const q = searchParams.get('q') || '';
  const categoria = searchParams.get('categoria') || '';
  const estado = searchParams.get('estado') || '';
  const [results, setResults] = useState([]);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let active = true;
    setStatus('loading');
    fetchProviders({ q, category: categoria, state: estado, limit: 50 })
      .then((data) => {
        if (!active) return;
        setResults(data.providers);
        setStatus('ready');
      })
      .catch(() => active && setStatus('error'));
    return () => {
      active = false;
    };
  }, [q, categoria, estado]);

  return (
    <section className="section page-section">
      <div className="section-header">
        <h1>Buscar proveedores</h1>
        <p>Refina tu búsqueda por nombre, categoría o estado de la república.</p>
      </div>
      <SearchBar />
      {status === 'error' && (
        <p className="empty-state">No pudimos completar la búsqueda. Verifica tu conexión e intenta de nuevo.</p>
      )}
      {status === 'ready' && (
        <>
          <p className="results-count">{results.length} resultados encontrados</p>
          {results.length > 0 ? (
            <div className="provider-grid">
              {results.map((p) => <ProviderCard provider={p} key={p.id} />)}
            </div>
          ) : (
            <p className="empty-state">No encontramos proveedores con esos filtros. Intenta con otra búsqueda.</p>
          )}
        </>
      )}
    </section>
  );
}
